import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CSSProperties } from 'vue';
import { Statistic } from 'ant-design-vue';

interface Props {
  title?: string;
  value: string | number;
  precision?: number;
  valueStyle?: CSSProperties;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RexStatisticV3',
  props: {
    title: { default: '' },
    value: {},
    precision: { default: 3 },
    valueStyle: { default: () => ({ fontSize: '1rem', color: '#F59600' }) }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Statistic), {
    title: props.title,
    value: props.value,
    precision: props.precision,
    valueStyle: props.valueStyle
  }, null, 8, ["title", "value", "precision", "valueStyle"]))
}
}

})